var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLicenceone = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.125 0H2.875C1.28718 0 0 1.28718 0 2.875V20.125C0 21.7128 1.28718 23 2.875 23H20.125C21.7128 23 23 21.7128 23 20.125V2.875C23 1.28718 21.7128 0 20.125 0Z",
    fill: "#E30914"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0752 6.46875C12.0752 6.8657 12.397 7.1875 12.7939 7.1875H16.3877V17.9687C16.3877 18.3657 16.7095 18.6875 17.1064 18.6875H18.5439C18.9409 18.6875 19.2627 18.3657 19.2627 17.9687V5.03125C19.2627 4.6343 18.9409 4.3125 18.5439 4.3125H12.7939C12.397 4.3125 12.0752 4.6343 12.0752 5.03125V6.46875Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60645 4.3125C5.20949 4.3125 4.8877 4.6343 4.8877 5.03125V17.9687C4.8877 18.3657 5.20949 18.6875 5.60645 18.6875H11.3564C11.7534 18.6875 12.0752 18.3657 12.0752 17.9687V16.5312C12.0752 16.1343 11.7534 15.8125 11.3564 15.8125H7.7627V5.03125C7.7627 4.6343 7.4409 4.3125 7.04395 4.3125H5.60645Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLicenceone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/licenceone.bc8ae9d8aebb227948d85576c554fe66.svg";